import { Info } from '@phosphor-icons/react';

export function DataNote({ className = '' }) {
  return (
    <p className={`text-[11px] text-amber-800 dark:text-amber-300 bg-amber-500/10 border border-amber-500/30 rounded-md px-3 py-1.5 flex items-start gap-1.5 ${className}`} data-testid="data-accuracy-note">
      <Info size={13} className="mt-0.5 shrink-0" />
      These figures are calculated from the entries recorded in the system. If an entry is wrong or missing, the figures will differ.
    </p>
  );
}
